module.exports = __webpack_public_path__ + "static/media/fastGamesPlayed_100000_250000.2690b860.png";